const environmentData = {
  "nulogy-pm-production/packmanager-training": {
    dqiEnvironment: "nulogy-qcloud-production/qcloud-sandbox",
    dqiUrl: "https://training.qc.nulogy.net",
    opsCoreUrl: "https://training.app.nulogy.net",
    readableEnvironmentName: "Training",
  },
  "nulogy-pm-test/opscore-na-test": {
    dqiEnvironment: "nulogy-qcloud-test/qcloud-qa",
    dqiUrl: "https://master.qa-qc.nulogy.net",
    opsCoreUrl: "https://na.qa-app.nulogy.net",
    readableEnvironmentName: "NA Test",
  },
  "nulogy-pm-test/opscore-davidt": {
    dqiEnvironment: "nulogy-qcloud-test/qcloud-qa",
    dqiUrl: "https://master.qa-qc.nulogy.net",
    opsCoreUrl: "https://davidt.qa-app.nulogy.net",
    readableEnvironmentName: "David T",
  },
  "nulogy-pm-test/opscore-melissam": {
    dqiEnvironment: "nulogy-qcloud-test/qcloud-qa",
    dqiUrl: "https://master.qa-qc.nulogy.net",
    opsCoreUrl: "https://melissam.qa-app.nulogy.net",
    readableEnvironmentName: "Melissa M",
  },
  "nulogy-pm-test/opscore-nathanielf": {
    dqiEnvironment: "nulogy-qcloud-test/qcloud-qa",
    dqiUrl: "https://master.qa-qc.nulogy.net",
    opsCoreUrl: "https://nathanielf.qa-app.nulogy.net",
    readableEnvironmentName: "Nathan F",
  },
};

export function pipelineForApp(demoConfiguration) {
  const pipelines = {
    dqi: "qcloud-create-demo",
    opsCore: "opscore-create-demo",
  };

  return pipelines[demoConfiguration.app];
}

export function getAppUrl(demoConfiguration) {
  return environmentData[demoConfiguration.environment][
    `${demoConfiguration.app}Url`
  ];
}

export function getAppName(app) {
  const names = {
    dqi: "DQI",
    opsCore: "Ops Core",
  };

  return names[app];
}

export function getEnvironmentKey(app) {
  const keys = {
    dqi: "release-environment",
    ops: "deploy-environment",
    opsCore: "deploy-environment",
  };

  return keys[app];
}

export function getEnvironment(demoConfiguration) {
  if (demoConfiguration.app === "opsCore") return demoConfiguration.environment;

  return environmentData[demoConfiguration.environment]["dqiEnvironment"];
}

export function getCreatableEnvironments() {
  const environmentNames = getFieldForEnvironments("readableEnvironmentName");
  return Object.keys(environmentNames).map((key) => {
    return { environment: key, name: environmentNames[key] };
  });
}

export function getReadableEnvironment(environment) {
  const opsCoreToDqiEnvMapping = Object.assign(
    getFieldForEnvironments("readableEnvironmentName"),
    {
      "nulogy-qcloud-test/qcloud-qa": "QA",
      "nulogy-qcloud-production/qcloud-sandbox": "Training",
    },
  );

  return opsCoreToDqiEnvMapping[environment];
}

export function getNormalizedCompanyName(demoConfiguration) {
  return demoConfiguration.companyName
    .toLowerCase()
    .replace('"', "")
    .replace(/\s/g, "");
}

function getFieldForEnvironments(fieldName) {
  return Object.keys(environmentData).reduce((result, key) => {
    result[key] = environmentData[key][fieldName];
    return result;
  }, {});
}
